
import Colors from "constants/Colors";

const globalStyles = {
  components: {
    menu: {
      title: Colors.GRAY[8],
      subtitle: Colors.GREEN,
      activeItem: Colors.GRAY[8],
      inactiveItem: Colors.GRAY[9],
      activeItemBorder: Colors.SECONDARY,
      inactiveItemBorder: Colors.GRAY[9],
      activeItemBackgroundColor: Colors.SECONDARY,
    },

    list2: {
      rowFilter: Colors.GREEN,
    },

    brokingSummary: {
      label: Colors.GRAY[2],
      text: Colors.GRAY[6],
    },

    button: {
      primaryMixin: {
        primary: Colors.WHITE,
        secondary: Colors.PRIMARY1,
      },
      secondaryMixin: {
        primary: Colors.WHITE,
        secondary: Colors.GREEN,
      },
      thirdMixin: {
        primary: Colors.WHITE,
        secondary: Colors.GRAY[6],
        terciary: Colors.GRAY[0],
        quaternary: Colors.GRAY[3],
      },
      forthMixin: {
        primary: Colors.GRAY[6],
      },
      outlinePrimaryMixin: {
        primary: Colors.WHITE,
        secondary: Colors.SECONDARY,
      },
      noBorderPrimaryMixin: {
        primary: Colors.PRIMARY,
        secondary: Colors.SECONDARY,
      },
    },

    button2: {
      primaryMixin: {
        primary: Colors.WHITE,
        secondary: Colors.SECONDARY,
      },
      outlinePrimaryMixin: {
        primary: Colors.WHITE,
        secondary: Colors.SECONDARY,
      },
      noBorderPrimaryMixin: {
        primary: Colors.PRIMARY,
        secondary: Colors.SECONDARY,
      },
      forthMixin: {
        primary: Colors.GRAY[6],
      },
    },

    button3: {
      primaryMixin: {
        primary: Colors.WHITE,
        secondary: Colors.SECONDARY,
      },
      outlinePrimaryMixin: {
        primary: Colors.WHITE,
        secondary: Colors.SECONDARY,
      },
      noBorderPrimaryMixin: {
        primary: Colors.PRIMARY,
        secondary: Colors.SECONDARY,
      },
    },

    buttonCalendar: {
      primaryMixin: {
        primary: Colors.WHITE,
        secondary: Colors.SECONDARY,
      },
      secondaryMixin: {
        primary: Colors.WHITE,
        secondary: Colors.YELLOW,
      },
      thirdMixin: {
        primary: Colors.WHITE,
        secondary: Colors.GRAY[6],
        terciary: Colors.GRAY[0],
        quaternary: Colors.GRAY[3],
      },
      forthMixin: {
        primary: Colors.GRAY[6],
      },
      outlinePrimaryMixin: {
        primary: Colors.WHITE,
        secondary: Colors.SECONDARY,
      },
      noBorderPrimaryMixin: {
        primary: Colors.PRIMARY,
        secondary: Colors.SECONDARY,
      },
    },

    buttonUpload: {
      primary: Colors.PRIMARY,
      secondary: Colors.YELLOW,
    },

    card: {
      background: Colors.GRAY[5],
      color: Colors.PRIMARY,
    },

    chip: {
      background: Colors.SECONDARY,
      color: Colors.PRIMARY,
    },

    contentCard: {
      content: {
        border: Colors.GRAY[5],
        background: Colors.WHITE,
        box_shadow: Colors.GRAY[4],
      },
      heading: {
        border: Colors.GRAY[5],
        background: Colors.WHITE,
        color: Colors.GRAY[7],
      },
      filterContainer: Colors.WHITE,
      mobileLabel: Colors.GREEN,
    },

    dialog: {
      dialog_background: "rgba(255, 255, 255, 0.4)",
      dialog_body: {
        background: Colors.WHITE,
        box_shadow: Colors.GRAY[3],
      },
      dialog_icon: {
        color: Colors.PINK,
        display: Colors.BLACK,
      },
      dialog_text: {
        color: Colors.GRAY[6],
      },
      dialog_confirm: {
        background: Colors.PINK,
        color: Colors.WHITE,
      },
      text_area: {
        border: Colors.GRAY[3],
        color: Colors.GRAY[6],
      },
      dialog_rejected: {
        background: Colors.PURPLE,
        color: Colors.WHITE,
      },
      content_text_area: Colors.GRAY[0],
    },

    dialog_alert_message: {
      dialog_background: "rgba(255, 255, 255, 0.4)",
      dialog_body: {
        background: Colors.WHITE,
        box_shadow: "rgb(192 192 192)",
      },
      dialog_icon: {
        color: Colors.PINK,
        display: Colors.BLACK,
      },
      dialog_text: {
        color: Colors.GRAY[6],
      },
      dialog_confirm: {
        background: Colors.PINK,
        color: Colors.WHITE,
      },
      text_area: {
        border: Colors.GRAY[3],
        color: Colors.GRAY[6],
      },
      dialog_rejected: {
        background: Colors.PURPLE,
        color: Colors.WHITE,
      },
      content_text_area: Colors.GRAY[0],
    },

    dialog_edit_person: {
      dialog_background: "rgba(255, 255, 255, 0.4)",
      dialog_body: {
        background: Colors.WHITE,
        box_shadow: "rgb(192 192 192)",
      },
      dialog_icon: {
        color: Colors.PINK,
        display: Colors.BLACK,
      },
      dialog_text: {
        color: Colors.GRAY[6],
      },
      dialog_confirm: {
        background: Colors.PINK,
        color: Colors.WHITE,
      },
      text_area: {
        border: Colors.GRAY[3],
        color: Colors.GRAY[6],
      },
      dialog_rejected: {
        background: Colors.PURPLE,
        color: Colors.WHITE,
      },
      content_text_area: Colors.GRAY[0],
    },

    stepNavigation: {
      circle: {
        background: Colors.GREEN,
        border: Colors.GREEN,
      }
    }
  },
};

export default globalStyles;